<template>
  <v-container
    id="edit-product"
    fluid
    tag="section"
  >
    <v-card
      class="mx-auto pa-5"
      outlined
    >
      <validation-observer v-slot="{ handleSubmit }">
        <v-form
          @submit.prevent="handleSubmit(update)"
        >
            <div style="background: #EFEFFE; padding:  10px 15px;border-radius: 3px;">
              <h3 style="text-transform: uppercase">
                Thông tin sản phẩm
              </h3>
            </div>
          <v-alert
            v-show="alertMessageText"
            v-model="alert"
            :type="alertMessageType"
            dismissible
          >
            {{ alertMessageText }}
          </v-alert>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                name="Tên sản phẩm"
                rules="required|max:255"
              >
                <v-text-field
                  v-model="details.name"
                  label="Tên sản phẩm *"
                  :error-messages="errors"
                  color="primary"
                />
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                name="Mã sản phẩm"
                :rules="{
                  required: true,
                  regex: regex.isUsername,
                }"
              >
                <v-text-field
                  v-model="details.code"
                  label="Mã sản phẩm *"
                  :error-messages="errors"
                  color="primary"
                />
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                name="Giá bán lẻ"
                :rules="{ required: true, max: 9, regex: /^[0-9]*$/ }"
              >
                <v-currency-field
                  label="Giá bán lẻ *"
                  :error-messages="errors"
                  v-model="details.price"
                />
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                name="Đơn vị"
                rules="required"
              >
                <v-text-field
                  v-model="details.unit"
                  label="Đơn vị *"
                  :error-messages="errors"
                  color="primary"
                />
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                name="Nhóm sản phẩm"
                rules="required"
              >
                <v-select
                  v-model="details.groupId"
                  label="Nhóm sản phẩm *"
                  no-data-text="Không có dữ liệu"
                  :items="serviceGroups"
                  item-text="name"
                  item-value="id"
                  :error-messages="errors"
                  color="primary"
                >
                  <template v-slot:item="{ attrs, item, on }">
                    <v-list-item
                      v-bind="attrs"
                      active-class="secondary elevation-4 white--text"
                      class="mx-3 mb-3 v-sheet"
                      elevation="0"
                      v-on="on"
                    >
                      <v-list-item-content>
                        <v-list-item-title v-text="item.name" />
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                name="Công ty"
              >
                <v-select
                  v-model="details.siteId"
                  label="Công ty"
                  no-data-text="Không có dữ liệu"
                  :items="sites"
                  item-text="name"
                  item-value="id"
                  :error-messages="errors"
                  color="primary"
                  clearable
                >
                  <template v-slot:item="{ attrs, item, on }">
                    <v-list-item
                      v-bind="attrs"
                      active-class="secondary elevation-4 white--text"
                      class="mx-3 mb-3 v-sheet"
                      elevation="0"
                      v-on="on"
                    >
                      <v-list-item-content>
                        <v-list-item-title v-text="item.name" />
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                name="Môn học"
                rules="required"
              >
                <v-select
                  v-model="details.monCode"
                  label="Môn học *"
                  no-data-text="Không có dữ liệu"
                  :items="subjectGroup"
                  item-text="name"
                  item-value="code"
                  :error-messages="errors"
                  color="primary"
                  clearable
                  @change="{details.curriculumId = null; getProgram}"
                >
                  <template v-slot:item="{ attrs, item, on }">
                    <v-list-item
                      v-bind="attrs"
                      active-class="secondary elevation-4 white--text"
                      class="mx-3 mb-3 v-sheet"
                      elevation="0"
                      v-on="on"
                    >
                      <v-list-item-content>
                        <v-list-item-title v-text="item.name" />
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </v-col>
            <v-col
                v-if="enableRow"
                cols="12"
                md="6">
              <validation-provider
                  v-slot="{ errors }"
                  name="Loại giáo viên"
                  rules="required"
              >
                <v-select
                    v-model="details.teacherType"
                    :error-messages="errors"
                    label="Loại giảng viên *"
                    no-data-text="Không có dữ liệu"
                    :items="teacherType"
                    item-text="name"
                    item-value="id"
                    color="primary"
                    clearable
                    item-disabled="disable"
                >
                </v-select>
              </validation-provider>
            </v-col>
            <v-col
                cols="12"
                md="6"
            >
              <validation-provider
                  v-slot="{ errors }"
                  name="Chọn loại sản phẩm"
                  rules="required"
              >
                <v-select
                    v-model="details.productType"
                    label="Loại sản phẩm *"
                    no-data-text="Không có dữ liệu"
                    :items="listTypeProduct"
                    item-text="name"
                    item-value="code"
                    :error-messages="errors"
                    @change="changeTypeProduct(details.productType)"
                    color="primary"
                    clearable
                >
                  <template v-slot:item="{ attrs, item, on }">
                    <v-list-item
                      v-bind="attrs"
                      active-class="secondary elevation-4 white--text"
                      class="mx-3 mb-3 v-sheet"
                      elevation="0"
                      v-on="on"
                    >
                      <v-list-item-content>
                        <v-list-item-title v-text="item.name" />
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="6"
              v-if="disableClassType"
            >
              <validation-provider
                v-slot="{ errors }"
                name="Loại lớp"
                rules="required"
              >
                <v-select
                  v-model="details.classType"
                  :error-messages="errors"
                  label="Loại lớp *"
                  no-data-text="Không có dữ liệu"
                  :items="classType"
                  item-text="name"
                  item-value="id"
                  color="primary"
                  clearable
                >
                </v-select>
              </validation-provider>
            </v-col>

            <!-- THI_THU -->
            <template v-if="details.productType === PRODUCT_TYPE.THI_THU">
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="Phân loại kỳ thi"
                  :rules="{ required: true }"
                >
                  <v-select
                    v-model="details.examTypeId"
                    label="Phân loại kỳ thi *"
                    :items="listExamType"
                    item-text="name.name"
                    item-value="id"
                    :error-messages="errors"
                    @change="changeExam()"
                  ></v-select>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="Chế độ thi"
                  :rules="{ required: true }"
                >
                  <v-select
                    v-model="details.examMode"
                    label="Chế độ thi *"
                    :items="[
                      { id: 'private', name: 'Private' },
                      { id: 'public', name: 'Public' },
                    ]"
                    item-text="name"
                    item-value="id"
                    @change="changeExam()"
                    :error-messages="errors"
                  ></v-select>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="Kỳ thi"
                  :rules="{ required: details.examMode === 'private' }"
                >
                  <v-select
                    v-model="details.examId"
                    label="Kỳ thi *"
                    :items="listExam"
                    item-text="name"
                    item-value="id"
                    :error-messages="errors"
                    clearable
                    @change="changeItemExam"
                  ></v-select>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="Số lượt thi"
                  :rules="{ required: true, max: 9, regex: /^[0-9]*$/ }"
                >
                  <v-currency-field
                    label="Số lượt thi *"
                    :error-messages="errors"
                    v-model="details.examTakeTimes"
                  />
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="Giá gốc"
                  :rules="{ required: true, max: 9, regex: /^[0-9]*$/ }"
                >
                  <v-currency-field
                    label="Giá gốc *"
                    :error-messages="errors"
                    v-model="details.originalPrice"
                  />
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="Loại hiển thị"
                  :rules="{ required: true }"
                >
                  <v-select
                    v-model="details.visibility"
                    label="Loại hiển thị *"
                    :items="[
                      { id: 'private', name: 'Private' },
                      { id: 'public', name: 'Public' },
                    ]"
                    item-text="name"
                    item-value="id"
                    :error-messages="errors"
                  ></v-select>
                </validation-provider>
              </v-col>
            </template>

            <!-- class="pt-0" @input="applyPendingPage(getTotalItem(totalItem, limit))" -->

            <v-col v-if="details.productType === 'GIA_SU'"
                   cols="12" md="6">
              <validation-provider
                  v-slot="{ errors }"
                  name="Nhập số buổi học"
                  :rules="{ required: true }"
              >
                <v-text-field
                  v-model="details.numberOfSection"
                  max="100"
                  min="1"
                  type="number"
                  :error-messages="errors"
                  label="Nhập số buổi học *"
                >
                </v-text-field>
              </validation-provider>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="gradeGroup"
              v-if="details.productType !== PRODUCT_TYPE.THI_THU"
            >
                <v-select
                  v-model="details.khoiCode"
                  label="Khối học"
                  no-data-text="Không có dữ liệu"
                  :items="gradeGroup"
                  item-text="name"
                  item-value="code"
                  color="primary"
                  multiple
                  clearable
                >
                </v-select>
                <div class="hint-gradeGroup">
                   <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon  v-bind="attrs"
                        v-on="on">mdi-help-circle-outline</v-icon>
                    </template>
                    <span>Khối học thực tế của học sinh. Ví dụ Học tốt toán 3 sẽ cần chọn khối 3 và 4</span>
                </v-tooltip>
                </div>
              </v-col>
            <v-col cols="12" md="6" v-if="details.productType !== PRODUCT_TYPE.THI_THU">
              <validation-provider
                  v-slot="{ errors }"
                  name="Nhập loại chương trình"
                  :rules="{ required: true }"
              >
                <v-select
                    v-model="details.programType"
                    :items="programs"
                    item-text="name"
                    item-value="code"
                    multiple
                    :error-messages="errors"
                    label="Loại chương trình *"
                >
                </v-select>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="6" v-if="details.productType === 'GIA_SU' && details.monCode">
              <validation-provider
                  v-slot="{ errors }"
                  name="Chọn chương trình"
                  :rules="{ required: true }"
              >
                <v-autocomplete
                    :error-messages="errors"
                    :items="curriculums"
                    item-text="title"
                    item-value="id"
                    label="Chương trình *"
                    clearable
                    v-model="details.curriculumId"
                    @change="changeCurriculum(details.curriculumId)"
                >

                </v-autocomplete>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="6" v-if="details.productType === PRODUCT_TYPE.GIA_SU && details.monCode">
              <validation-provider
                  v-slot="{ errors }"
                  name="Chọn lộ trình"
                  :rules="{ required: true }"
              >
                <v-autocomplete
                    :error-messages="errors"
                    :items="programGroupsChild"
                    item-text="title"
                    :disabled="!details.curriculumId || details.curriculumId == ''"
                    multiple
                    clearable
                    item-value="id"
                    label="Lộ trình *"
                    v-model="details.programGroups"
                >
                </v-autocomplete>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="6" v-if="details.productType !== PRODUCT_TYPE.HIEN_VAT">
              <validation-provider
                v-slot="{ errors }"
                name="Tên trên thẻ học"
                rules="required|max:25"
              >
                <v-text-field
                  v-model="details.printCardText"
                  label="Tên trên thẻ học *"
                  :error-messages="errors"
                  color="primary"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="6" v-if="details.productType === PRODUCT_TYPE.GIA_SU">
              <v-select
                  v-model="details.arrangeCondition"
                  label="Điều kiện xếp lớp"
                  multiple
                  :items="[{id: 'grade_id', name: 'Khối lớp'}, {id: 'level', name: 'Trình độ'}, {id: 'school', name: 'Trường học'}]"
                  item-text="name"
                  item-value="id"
              ></v-select>
            </v-col>
          </v-row>

          <div class="service-form-pictures" v-if="details.productType !== PRODUCT_TYPE.THI_THU">
            <v-file-input
              show-size
              v-model="details.files"
              accept="image/*"
              label="Hình ảnh"
              multiple
              prepend-icon="mdi-paperclip"
              placeholder="Ảnh sản phẩm"
              @change="changeFiles"
            >
              <template v-slot:selection="{ text }">
                <v-chip
                  small
                  label
                  color="primary"
                >
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <validation-provider
              v-slot="{ errors }"
              name="Ảnh sản phẩm"
              class="thumbnail-validation"
            >
              <div>
                <v-text-field
                  v-model="hasImage"
                  label="Ảnh sản phẩm *"
                  :error-messages="errors"
                  color="primary"
                  class="clear-both"
                />
              </div>
            </validation-provider>

            <div class="group--product" v-show="displayImages.length ? true : false">
              <div
                v-for="displayImage in displayImages"
                :key="displayImage.id"
                class="display-image-block"
              >
                <div class="delete-image-block">
                  <v-icon
                    small
                    @click="deleteImage(displayImage)"
                  >
                    mdi-delete
                  </v-icon>
                </div>
                <v-img
                  :src="_.get(displayImage, 'filePath')"
                  gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
                  style="height: 200px; width: 100%"
                />
                <v-radio-group
                  v-model="thumbnailId"
                >
                  <v-radio
                    :key="_.get(displayImage, 'id')"
                    label="Chọn làm ảnh chính"
                    :value="_.get(displayImage, 'id')"
                  />
                </v-radio-group>
              </div>

              <validation-provider
                v-slot="{ errors }"
                name="Chọn ảnh chính"
                class="thumbnail-validation"
              >
                <div>
                  <v-text-field
                    v-model="thumbnailId"
                    label="Ảnh thumb"
                    :error-messages="errors"
                    color="primary"
                    class="clear-both"
                  />
                </div>
              </validation-provider>
            </div>
          </div>
<!--          CRMINTER-1870: Thêm sp có thời hạn  -->
            <template v-if="details.productType === PRODUCT_TYPE.KHOA_HOC || details.productType === PRODUCT_TYPE.GIA_SU">
               <div style="background: #EFEFFE; padding:  10px 15px;border-radius: 3px;">
                   <h3 style="text-transform: uppercase;">
                       Thông tin hạn học
                   </h3>
               </div>
                <v-row>
                    <v-col cols="6" md="6">
                        <validation-provider
                                v-slot="{ errors }"
                                name="Phương thức kích hoạt khóa học"
                                :rules="{ required: true }"
                        >
                            <v-select
                                    v-model="details.endDateActiveType"
                                    :items="listCourseActivationMethod"
                                    item-text="name"
                                    item-value="id"
                                    multiple
                                    clearable
                                    :error-messages="errors"
                                    label="Phương thức kích hoạt khóa học *"
                                    :menu-props="{ top: true, offsetY: true , maxHeight: 200}"
                            >
                                <template v-slot:selection="{ item, index }" >
                                     {{ item.name }}
                                    <span v-if="item.content"
                                          style="font-size: 11px !important; font-weight: 500; font-style: italic"
                                    > ( {{ item.content }} ) </span> <span v-if="index < details.endDateActiveType.length -1 " style="margin-right: 3px;">, </span>

                                </template>
                                <template v-slot:item="{ active, item, attrs, on }">
                                    <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                                        <v-list-item-action>
                                            <v-checkbox :input-value="active"></v-checkbox>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <span> {{ item.name }}</span>
                                                <span v-if="item.content"
                                                      style="font-size: 11px !important; font-weight: 500; font-style: italic"
                                            > ( {{ item.content }} ) </span>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </validation-provider>
                    </v-col>
                    <v-col
                            cols="3"
                            md="3"
                    >
                        <validation-provider
                                v-slot="{ errors }"
                                name="Chọn loại thời hạn sử dụng chung"
                                :rules="{ required: true }"
                        >
                            <v-select
                                    v-model="details.typeEndDate"
                                    label="Loại thời hạn sử dụng chung"
                                    no-data-text="Không có dữ liệu"
                                    :items="listTypeEndDate"
                                    item-text="title"
                                    item-value="type"
                                    @change="handleTypeEndDate"
                                    :error-messages="errors"
                                    color="primary"
                                    :menu-props="{ top: true, offsetY: true , maxHeight: 200}"

                            >
                                <template v-slot:item="{ attrs, item, on }">
                                    <v-list-item
                                            v-bind="attrs"
                                            active-class="secondary elevation-4 white--text"
                                            class="mx-3 mb-3 v-sheet"
                                            elevation="0"
                                            v-on="on"
                                    >
                                        <v-list-item-content>
                                            <v-list-item-title v-text="item.title" />
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </validation-provider>
                    </v-col>
                    <v-col v-if="(details.productType === PRODUCT_TYPE.KHOA_HOC || details.productType === PRODUCT_TYPE.GIA_SU) && details.typeEndDate === 'month'"
                           cols="3" md="3"
                    >
                        <validation-provider
                                v-slot="{ errors }"
                                name="Nhập số tháng"
                                :rules="{ required: true }"
                        >
                            <v-currency-field
                                    :min="1"
                                    label="Nhập số tháng"
                                    :error-messages="errors"
                                    v-model="details.endMonth"
                            />
                        </validation-provider>
                    </v-col>
                    <v-col v-if="(details.productType === PRODUCT_TYPE.KHOA_HOC || details.productType === PRODUCT_TYPE.GIA_SU) && details.typeEndDate === 'day'" cols="3" md="3">
                        <v-menu
                                ref="datePicker"
                                v-model="datePicker"
                                :close-on-content-click="false"
                                :return-value.sync="details.endDate"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <validation-provider
                                        v-slot="{ errors }"
                                        name="Chọn ngày"
                                        :rules="{required: true, after: afterDate,}"
                                        :immediate="false"
                                >
                                    <v-text-field
                                            style="margin-left: -4px"
                                            v-model="details.endDate"
                                            color="primary"
                                            label="Chọn ngày "
                                            :error-messages="errors"
                                            prepend-icon="mdi-calendar-outline"
                                            readonly
                                            v-on="on"
                                    />
                                </validation-provider>
                            </template>

                            <v-date-picker
                                    v-model="details.endDate"
                                    color="secondary"
                                    scrollable
                                    @change="$refs.datePicker.save(details.endDate), datePicker = false"
                                    :min="currentDate"
                            >
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                <template v-if="details.endDateLearnType.length">
                    <v-row v-for="(giveMore, index) in details.endDateLearnType" :key="index+'give-more'">
                        <v-col cols="6" md="6">
                            <validation-provider
                                    v-slot="{ errors }"
                                    name="Thành phần tặng thêm hạn"
                                    :rules="{ required: true }"
                                    :vid="`learnType${index}`"
                            >
                                <v-select
                                        v-model="giveMore.learnType"
                                        :items="listTypeMethod"
                                        item-text="name"
                                        item-value="id"
                                        item-disabled="disable"
                                        multiple
                                        clearable
                                        @focus="handleGiftIngredients(index)"
                                        :error-messages="errors"
                                        label="Thành phần tặng thêm hạn *"
                                        :menu-props="{ top: true, offsetY: true , maxHeight: 270}"
                                >
                                </v-select>
                            </validation-provider>
                        </v-col>
                        <v-col
                                cols="3"
                                md="3"
                        >
                            <validation-provider
                                    v-slot="{ errors }"
                                    name="chọn loại thời hạn tặng thêm"
                                    :rules="{ required: true }"
                                    :vid="`typeShelfLife${index}`"
                            >
                                <v-select
                                        v-model="typeLearnDate"
                                        label="Loại thời hạn tặng thêm *"
                                        no-data-text="Không có dữ liệu"
                                        :items="listTypeEndDate"
                                        item-text="title"
                                        item-value="type"
                                        :error-messages="errors"
                                        color="primary"
                                        :menu-props="{ bottom: true, offsetY: true , maxHeight: 200}"
                                        readonly
                                >
                                    <template v-slot:item="{ attrs, item, on }">
                                        <v-list-item
                                                v-bind="attrs"
                                                active-class="secondary elevation-4 white--text"
                                                class="mx-3 mb-3 v-sheet"
                                                elevation="0"
                                                v-on="on"
                                        >
                                            <v-list-item-content>
                                                <v-list-item-title v-text="item.title" />
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                </v-select>
                            </validation-provider>
                        </v-col>
                        <v-col v-if="typeLearnDate === 'month'"
                               cols="3" md="3"
                        >
                            <div class="d-flex" style="column-gap: 10px">
                                <div style="width: calc(100% - 30px)">
                                  <validation-provider
                                          v-slot="{ errors }"
                                          name="Nhập số tháng"
                                          :rules="{ required: true, regex: /^[0-9]*$/ }"
                                          :vid="`endDate-month${index}`"
                                  >
                                      <v-currency-field
                                              :min="1"
                                              label="Nhập số tháng"
                                              :error-messages="errors"
                                              v-model="giveMore.endMonth"
                                      />
                                  </validation-provider>
                                </div>
                                <v-icon style="width: 20px;cursor: pointer" @click.prevent="removeGiveMore(index)">mdi-delete-forever </v-icon>
                            </div>
                        </v-col>
                        <v-col v-if="typeLearnDate === 'day'" cols="3" md="3">
                           <div class="d-flex" style="column-gap: 10px">
                               <div style="width: calc(100% - 30px)">
                                   <v-menu

                                           ref="datePickerMenu"
                                           v-model="datePickerMenu[details.endDateLearnType.indexOf(giveMore)]"
                                           :close-on-content-click="false"
                                           :return-value.sync="giveMore.endDate"
                                           transition="scale-transition"
                                           offset-y
                                           max-width="290px"
                                           min-width="290px"
                                   >
                                       <template v-slot:activator="{ on }">
                                           <validation-provider
                                                   v-slot="{ errors }"
                                                   name="Chọn ngày"
                                                   :rules="{required: true, after: details.endDate}"
                                                   :immediate="false"
                                                   :vid="`endDate-day${index}`"
                                           >
                                               <v-text-field
                                                       style="margin-left: -4px"
                                                       v-model="giveMore.endDate"
                                                       color="primary"
                                                       label="Chọn ngày "
                                                       :error-messages="errors"
                                                       prepend-icon="mdi-calendar-outline"
                                                       readonly
                                                       v-on="on"
                                               />
                                           </validation-provider>
                                       </template>

                                       <v-date-picker
                                               v-model="giveMore.endDate"
                                               color="secondary"
                                               scrollable
                                               @change="$refs.datePickerMenu[index].save(giveMore.endDate), datePickerMenu[details.endDateLearnType.indexOf(giveMore)] = false"
                                               :min="details.endDate ? validateDateGift : currentDate"
                                       >
                                       </v-date-picker>
                                   </v-menu>
                               </div>
                               <v-icon style="width: 20px;cursor: pointer" @click.prevent="removeGiveMore(index)">mdi-delete-forever </v-icon>
                           </div>
                        </v-col>
                    </v-row>
                </template>
                <div class="d-flex align-center justify-end" style="font-style:italic;font-weight: 500;">
                   <span style="cursor: pointer" @click="addGiveMore"> <v-icon>mdi-plus</v-icon> Tặng thêm</span>
                </div>

            </template>
<!--            end CRMINTER-1870-->
          <div class="mt-2 text-center">
            <v-btn
              class="mb-2"
              color="primary"
              @click.prevent="handleSubmit(update)"
            >
              {{ isNew ? 'Tạo' : 'Cập nhật chỉnh sửa'
              }}
            </v-btn>
            <v-btn
              class="mb-2 mr-2"
              color="default"
              @click="goToList"
            >
              Hủy bỏ
            </v-btn>
          </div>
        </v-form>
      </validation-observer>
    </v-card>
  </v-container>
</template>
<script>
import {
    regex,
    MAX_SIZE_IMAGE,
    PRODUCT_TYPE,
    listCourseActivationMethod,
    listTypeShelfLife, ADDITIONAL_INGREDIENTS
} from '../../../../helpers/constants';
import RepositoryFactory from '@/repositories/RepositoryFactory'
import * as moment from "moment";
import {teacherType, classType, SUBJECTS_CURRICULUM} from "../../../../helpers/constants";

  const ProductRepository = RepositoryFactory.get('product')
  const ProductGroupRepository = RepositoryFactory.get('product_group')
  const ImageRepository = RepositoryFactory.get('image')
  const SiteRepository = RepositoryFactory.get('site')
  const SubjectRepository = RepositoryFactory.get('subject')
  const ExamRepository = RepositoryFactory.get('exam')
  const PAGE_LIMIT = 300
  const FIRST_PAGE = 0

  export default {
    $_veeValidate: {
      validator: 'new',
    },
    name: 'EditProductForm',
    props: {
      headerColor: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        listDataMethodDisableClone: [],
        listDataMethodDisable: [],
        listTypeMethod: ADDITIONAL_INGREDIENTS,
        listCourseActivationMethod,
        listTypeShelfLife,
        regex,
        isNew: false,
        typeLearnDate: '',
        details: {
          id: 0,
          code: '',
          name: '',
          price: '',
          groupId: '',
          status: 'draft',
          files: [],
          siteId: '',
          endDate: '',
          typeEndDate: '',
          endMonth: '',
          monCode: '',
          khoiCode: [],
          programType:[],
          productType: '',
          numberOfSection: '',
          classType: null,
          teacherType: null,
          curriculumId: null,
          printCardText: '',
          programGroups: [],
          arrangeCondition: [],
          // Thi_thu
          examTypeId: null,
          examName: null,
          examMode: null,
          examId: null,
          examType: null,
          examTakeTimes: null,
          originalPrice: null,
          visibility: null,
          endDateActiveType: [],
          endDateLearnType: [],

        },
        serviceGroups: [],
        files: null,
        displayImages: [],
        deleteImages: [],
        thumbnailId: null,
        alertMessageText: null,
        alertMessageType: 'success',
        alert: true,
        loading: false,
        sites: [],
        datePicker: false,
        datePickerMenu: [],
        listTypeEndDate: [
          {
            type: 'day',
            title: 'Chọn ngày'
          },
          {
            type: 'month',
            title: 'Chọn tháng'
          }
        ],
        subjectGroup: [],
        listTypeProduct: [
          {
            code: 'KHOA_HOC',
            name: 'Khóa học'
          },
          {
            code: 'HIEN_VAT',
            name: 'Hiện vật'
          },
          {
            code: 'GIA_SU',
            name: 'Gia sư'
          },
          {
            code: 'EXAM',
            name: 'Exam'
          },
        ],
        gradeGroup: [
          {
            code: '1',
            name: '1'
          },
          {
            code: '2',
            name: '2'
          },
          {
            code: '3',
            name: '3'
          },
          {
            code: '4',
            name: '4'
          },
          {
            code: '5',
            name: '5'
          },
          {
            code: '6',
            name: '6'
          },
          {
            code: '7',
            name: '7'
          },
          {
            code: '8',
            name: '8'
          },
          {
            code: '9',
            name: '9'
          },
          {
            code: '10',
            name: '10'
          },
          {
            code: '11',
            name: '11'
          },
          {
            code: '12',
            name: '12'
          },
          {
            code: 'GH',
            name: 'Gia hạn'
          },
          {
            code: '14',
            name: 'Tiền lớp 1'
          },
        ],
        programs:[{code:'CO_BAN',name:'Cơ bản'},{code:'NANG_CAO',name:'Nâng cao'}],
        teacherType:[...teacherType],
        classType,
        disableClassType:false,
        enableRow:false,
        curriculums: [],
        programGroupsChild: [],
        listExamType: [],
        listExam: [],
        PRODUCT_TYPE,
      }
    },
    computed: {
      validateDateGift() {
          return moment(this.details.endDate).add(1, "days").format('YYYY-MM-DD')
      },
      pageTitle () {
        return this.isNew ? 'Tạo sản phẩm' : 'Sửa sản phẩm'
      },
      hasImage () {
        return this.displayImages.length ? '1' : ''
      },
      currentDate () {
        return moment().format('YYYY-MM-DD')
      },
      afterDate () {
        return moment().subtract(1, "days").format('YYYY-MM-DD')
      }
    },
    async mounted () {
      this.getListExamType();
      let id = 0
      if ('id' in this.$route.params) {
        id = parseInt(this.$route.params.id, 10)
      }
      this.details.id = id
      this.isNew = !id
      await this.getDetails()
      await this.getSites()
      if ('id' in this.$route.params) {
        this.getProgram()
      }
    },
    methods: {
        handleTypeEndDate(value) {
            this.typeLearnDate = value
            this.details.endDate = ''
            if(value == 'month') {
                this.details.endDate = ''
               if(this.details.endDateLearnType.length) {
                   this.details.endDateLearnType.forEach(item => {
                       item.endMonth = ''
                   })
               }
            }
            if(value == 'day') {
                this.details.endMonth = ''
                if(this.details.endDateLearnType.length) {
                    this.details.endDateLearnType.forEach(item => {
                        item.endDate = ''
                    })
                }
            }
        },
      checkValidateGiftIngredients(index) {
            if(this.listDataMethodDisableClone.length > 0) {
                    this.listDataMethodDisable.forEach(i => {
                        if(i.id !== index) {
                            if(i.data.length) {
                                console.log('1234')
                                i.data.forEach(j => {
                                    this.listTypeMethod.forEach(item => {
                                        if(j === item.id) {
                                            item.disable= true
                                        }
                                    })
                                })
                            }
                        }else {
                            if(i.data.length) {
                                i.data.forEach(j => {
                                    this.listTypeMethod.forEach(item => {
                                        if(j === item.id) {
                                            item.disable= false
                                        }
                                    })
                                })
                            }
                        }
                    })
            } else {
                this.listTypeMethod = ADDITIONAL_INGREDIENTS
                this.listTypeMethod.forEach(item => {
                        item.disable= false
                })
            }
      },
      handleGiftIngredients(index) {
          this.checkValidateGiftIngredients(index)
      },
      removeGiveMore(index) {
          this.details.endDateLearnType.splice(index, 1);
          this.checkValidateGiftIngredients(index)
          this.listDataMethodDisable = this.listDataMethodDisable.filter(item => item.id !== index)
      },
      addGiveMore() {
          this.details.endDateLearnType.push({
              learnType: [],
              endDate: '',
              endMonth: '',
          })
      },
      deleteImage (item) {
        this.deleteImages.push(item.id)
        const self = this
        const newDisplayImages = []
        _.forEach(this.displayImages, function (item) {
          if (self.deleteImages.indexOf(item.id) === -1) {
            newDisplayImages.push(item)
          }
        })
        this.displayImages = newDisplayImages
      },
      async changeFiles () {
        if (this.details.files.length < 1 || this.details.files.length > 5) {
          if (this.details.files.length > 5) {
            this.setAlertMessage(true, 'error', 'Không thể tải lớn hơn 5 file đồng thời!')
          }
          return
        }
        let checkError = false;
        this.details.files.forEach(dataFile => {
          if (dataFile.size > MAX_SIZE_IMAGE) {
            checkError = true;
          }
        });
        if (checkError) {
          this.setAlertMessage(true, 'error', 'Không thể tải file ảnh lớn hơn 2 MB !');
          return
        }

        // this.loading = this.$loading.show()
        this.appLoadingData(true)
        const response = await ImageRepository.uploads(this.details.files)
        // this.loading.hide()
        this.appLoadingData(false)
        if (response.error) {
          this.setAlertMessage(true, 'error', 'Tải file thất bại!')
        } else {
          const tmpItems = _.get(response, 'data')
          tmpItems.forEach((item) => {
            this.displayImages.push(item)
          })
        }
      },

      // Lấy danh sách "Phân loại kỳ thi"
      async getListExamType() {
        const res = await ExamRepository.listType();
        if(res.success) {
          this.listExamType = res.data;
        }
      },

      // Thay đổi "phân loại || chế độ" => call lại api "danh sách kỳ thi"
      changeExam() {
        this.details.examId = null;
        const examTypeSelect = _.find(this.listExamType, { id: this.details.examTypeId });
        this.details.examType = _.get(examTypeSelect, "name.name", null);
        this.getListExam();
      },
      changeItemExam() {
        const examSelect = _.find(this.listExam, {id: this.details.examId});
        this.details.examName = _.get(examSelect, "name", null);
      },

      // Lấy danh sách "Kỳ thi"
      async getListExam() {
        const params = {
          examType: this.details.examTypeId,
          isInternal: this.details.examMode === 'private' ? 1 : null,
        };
        const res = await ExamRepository.listExam(params);
        if(res.success) {
          this.listExam = res.data;
        }
      },

      async update () {
        const images = []
        const self = this
        let imageId = null
        _.forEach(this.displayImages, function (displayImage) {
          imageId = _.get(displayImage, 'id', 0)
          images.push({
            id: imageId,
            isThumbnail: self.thumbnailId === imageId,
          })
        })
        if (this.details.arrangeCondition?.length > 0) {
          const arrange = this.details.arrangeCondition;
          arrange.sort()
          this.details.arrangeCondition = arrange.join(",")
        }
        if(this.details.endDateLearnType.length) {
            this.details.endDateLearnType.forEach(item => {
                if(this.details.typeEndDate === 'day') {
                    item.endDate = item.endDate ? item.endDate : null;
                    item.endMonth = null;
                } else if(this.details.typeEndDate === 'month') {
                    item.endMonth = item.endMonth ? item.endMonth : null;
                    item.endDate = null;
                }
            })
        }
        const details = {
          code: _.get(this.details, 'code', 0),
          name: _.get(this.details, 'name', 0),
          unit: _.get(this.details, 'unit', 0),
          price: _.get(this.details, 'price', 0),
          groupId: _.get(this.details, 'groupId', 0),
          images: images,
          siteId: _.get(this.details, 'siteId', null),
          monCode: _.get(this.details, 'monCode', null),
          khoiCode: this.details.khoiCode ?  _.get(this.details, 'khoiCode', []).join(',') : null,
          productType: _.get(this.details, 'productType', null),
          numberOfSection: _.get(this.details, 'numberOfSection', null),
          programType: this.details.programType ? _.get(this.details, 'programType') : [],
          classType: _.get(this.details,'classType'),
          teacherType: _.get(this.details,'teacherType'),
          curriculumId: _.get(this.details,'curriculumId'),
          printCardText: _.get(this.details,'printCardText'),
          programGroups: this.details.programGroups ? _.get(this.details, 'programGroups') : [],
          arrangeCondition: this.details.arrangeCondition?.length > 0 ? _.get(this.details, 'arrangeCondition') : '',
          // Thi Thu
          examTypeId: _.get(this.details, 'examTypeId', null),
          examType: _.get(this.details, 'examType', null),
          examMode: _.get(this.details, 'examMode', null),
          examId: _.get(this.details, 'examId', null),
          examName: _.get(this.details, 'examName', null),
          examTakeTimes: _.get(this.details, 'examTakeTimes', 0),
          originalPrice: _.get(this.details, 'originalPrice', 0),
          visibility: _.get(this.details, 'visibility', null),
          endDate: this.details.productType === 'EXAM' ? this.details.endDate : null,
          endDateActiveType: this.details.endDateActiveType ? _.get(this.details, 'endDateActiveType') : [],
          endDateLearnType: this.details.endDateLearnType ? _.get(this.details, 'endDateLearnType') : []
        }
        if(this.details.typeEndDate === 'day') {
          details.endDate = this.details.endDate ? this.details.endDate : null;
          details.endMonth = null;
        } else if(this.details.typeEndDate === 'month') {
          details.endMonth = this.details.endMonth ? this.details.endMonth : null;
          details.endDate = null;
        }
        // this.loading = this.$loading.show()
        this.appLoadingData(true)
        if (this.isNew) {
          const response = await ProductRepository.createV2(details)
          // this.loading.hide()
          this.appLoadingData(false)
          if (response.error) {
            this.setAlertMessage(true, 'error', _.get(response, 'message'))
          } else {
            this.$swal({
              title: 'Thêm sản phẩm thành công!',
              confirmButtonText: 'Đồng ý',
            },
            ).then(() => {
              this.goToList()
            })
          }
        } else {
          const response = await ProductRepository.updateV2(_.get(this.details, 'id', 0), details)
          // this.loading.hide()
          this.appLoadingData(false)
          if (response.error) {
            this.setAlertMessage(true, 'error', _.get(response, 'message'))
          } else {
            this.$swal({
              title: 'Cập nhật sản phẩm thành công!',
              confirmButtonText: 'Đồng ý',
            },
            ).then(() => {
              this.goToList()
            })
          }
        }
      },
      setAlertMessage (alert, type, text) {
        this.alert = alert
        this.alertMessageText = text
        this.alertMessageType = type
      },
      async getDetails () {
        // get service groups
        // this.loading = this.$loading.show()
        this.appLoadingData(true)
        const response = await ProductGroupRepository.list({
          page: FIRST_PAGE,
          limit: PAGE_LIMIT,
          keyword: '',
          status: 'active'
        })

        if (response.error) {
        } else {
          this.serviceGroups = _.get(response, 'data')
        }

        const res = await SubjectRepository.list()
        // this.loading.hide()
        this.appLoadingData(false)

        if (res.success) {
          this.subjectGroup = _.get(res, 'data', [])
        }


        if (!this.isNew) {
          // this.loading = this.$loading.show()
          this.appLoadingData(true)
          const response = await ProductRepository.getDetailV2(_.get(this.details, 'id', 0))
          // this.loading.hide()
          this.appLoadingData(false)
          if (response.error) {
            this.setAlertMessage(true, 'error', 'Lấy thông tin chi tiết sản phẩm thất bại!')
          } else {
            this.details = _.get(response, 'data')
            if (this.details.productType === PRODUCT_TYPE.THI_THU) {
              this.getListExam();
            };
            if (
              _.get(response, 'data.programGroups').length > 0
              && _.get(response, 'data.programGroups')[0].id
            ) {
              this.details.programGroups = _.get(response, 'data.programGroups').map(i => i.id);
            }
            const images = _.get(this.details, 'images', [])
            if (images.length) {
              const self = this
              let check
              _.forEach(images, function (item) {
                check = _.get(item, 'ImageItem.isThumbnail', false)
                if (check) {
                  self.thumbnailId = _.get(item, 'id', 0)
                }
                self.displayImages.push(item)
              })
            }
        // xu ly typeEndDate
            if(this.details.endDate) {
              this.details.typeEndDate = 'day'
            } else if(this.details.endMonth) {
              this.details.typeEndDate = 'month'
            } else {
              this.details.typeEndDate = ''
            }
            if (this.details.productType === PRODUCT_TYPE.GIA_SU && this.details.curriculumId) {
              setTimeout(() => {
                const curriculum = this.curriculums.filter(i => i.id === this.details.curriculumId);
                this.programGroupsChild = curriculum.length > 0 ? curriculum[0].program_groups : [];
              }, 1000);
            }
          }
        }
      },
      goToList () {
        this.$router.push({
          name: 'ProductList',
        })
      },
      getClass: function (headerColor) {
        return 'md-card-header-' + headerColor + ''
      },
      async getSites() {
        let res = await SiteRepository.list()
        if (res.success) {
          this.sites = _.get(res, 'data', [])
        } else {
          this.sites = []
        }
      },
      showModalAction(item) {
        console.log('item', item)
      },
      changeTypeProduct(productType) {
        this.listTypeEndDate = [
          {
            type: 'day',
            title: 'Chọn ngày'
          },
          {
            type: 'month',
            title: 'Chọn tháng'
          }
        ]

        if (productType === 'GIA_SU') {
          this.details.endDateActiveType = [1]
          this.details.endDate = ''
          this.details.endMonth = ''
          if (this.details.monCode) {
            this.getProgram()
          }
        } else if (productType === 'KHOA_HOC') {
          this.details.endDateActiveType = ''
          this.details.typeEndDate = 'day'
        } else return
      },
      async getProgram() {
        let subjectId
        console.log("details:", this.details)
        if (this.details.monCode) {
          const subject = this.subjectGroup.find(item => item.code == this.details.monCode);
          subjectId = SUBJECTS_CURRICULUM[subject.id] ?? subject.id;
        }
        const params = {
          obj: "program",
          "filters[$eq__subject_id]" : subjectId,
          "filters[$eq__status]": 1,
          attrs: ["id", "title"]
        }
        const response = await ProductRepository.getProgram(params)
        this.curriculums = _.get(response, "data", [])

      },
      changeCurriculum(value) {
        if (!value) return;
        const curriculum = this.curriculums.filter(i => i.id === value);
        this.programGroupsChild = curriculum[0].program_groups;
        this.details.programGroups = [];
      },
    },
   watch:{
        'details.typeEndDate'(value) {
                this.typeLearnDate = value
        },
        'details.endDateLearnType': {
            handler(val){
                if(val) {
                    let dataDisable = []
                    let dataDisableClone = []
                    _.forEach(val, function (item, key) {
                        dataDisableClone.push(item.learnType)
                        dataDisable.push({
                                id: key,
                                data: item.learnType
                            })
                      })
                    this.listDataMethodDisableClone  = [...new Set(dataDisableClone.flat())]
                    this.listDataMethodDisable = dataDisable
                }
            },
            deep: true
        },
    'details.monCode':function (){
      if(this.details.monCode.toLowerCase() != 'ta'){
        this.details.teacherType = null;
      }
      if (this.details.monCode.toLowerCase() == 'ta' && this.details.productType == 'GIA_SU'){
         this.enableRow = true;
      }else{
         this.enableRow = false;
      }
      this.getProgram();
    },
     'details.productType':function (){
      if (this.details.productType == 'GIA_SU'){
        this.disableClassType = true;
      }else {
        this.disableClassType = false;
        this.details.classType = null;
        this.details.curriculumId = null;
        this.details.programGroups = [];
        this.details.arrangeCondition = [];
      }
        if (this.details.monCode.toLowerCase() == 'ta' && this.details.productType == 'GIA_SU'){
          this.enableRow = true;
        }
        else if ((this.details.monCode.toLowerCase() == 'toan') && this.details.productType == 'GIA_SU'){
          this.enableRow = false;
        }else{
         this.enableRow = false;
        }
     }
  }
  }
</script>
<style lang="scss">
    .service-form-pictures {
        margin-top: 10px;
        font-size: 14px;
        font-weight: 400;
        color: #AAAAAA !important;
        line-height: 1.4;
    }
    .display-image-block {
      position: relative;
      max-width: 230px;
      width: 100%;
      margin-right: 20px;
      border: 1px solid #999;
      padding: 5px;
      display: inline-block;
    }
    .delete-image-block {
      position:absolute;
      right:5px;
      bottom: 32px;
      z-index: 9;
    }
    .v-card--material {
      overflow: hidden;
    }
    .clear-both {
      clear:both;
    }
    .display-none {
      display: none;
    }
    .thumbnail-validation {
      .v-text-field__slot {
        display: none !important;
      }
    }
  .v-input--radio-group__input .v-input--selection-controls__ripple {
    left: -12px;
  }
  .gradeGroup {
    position: relative;
    .hint-gradeGroup {
      position: absolute;
      top: 33px;
      right: -3px;
    }
  }
</style>
